'use client';

import {
	EventSubscriberType,
	GlobalEventSubscriberType,
} from '../../environmentVariables/EnvironmentVariableTypes';
import { SettingsClient } from '../../providers/settingsProvider';
import useFeatureFlagStore from 'src/stores/featureFlag/useFeatureFlagStore';

const EVENTS_SUBSCRIPTION_UTILS = {
	getPreferredGlobalEventSubscriptionType: ({
		ignoreUserSettings,
	}: {
		ignoreUserSettings: boolean;
	}) => {
		if (!ignoreUserSettings) {
			const userSetting =
				SettingsClient.getSettingSettings()?.globalEventsSubscriptionType;

			if (userSetting) {
				return userSetting;
			}
		}

		const dataApiTradePublisherIsEnabled = useFeatureFlagStore
			.getState()
			.flagEnabled('ENABLE_DATA_API_CANDLES_AND_TRADES_API');

		const preferredGlobalEventSubscriberType: GlobalEventSubscriberType =
			dataApiTradePublisherIsEnabled
				? 'data-api-trade-publisher'
				: 'dlob-server-trade-publisher';

		return preferredGlobalEventSubscriberType;
	},
	getPreferredSelfSubscriptionType: ({
		ignoreUserSettings,
	}: {
		ignoreUserSettings: boolean;
	}) => {
		if (!ignoreUserSettings) {
			const userSetting =
				SettingsClient.getSettingSettings().selfEventsSubscriptionType;

			if (userSetting) {
				return userSetting;
			}
		}

		const preferredSelfSubscriptionType: EventSubscriberType = 'events-server';

		return preferredSelfSubscriptionType;
	},
	getGlobalFallbackOption: (
		currentSubscriptionType: GlobalEventSubscriberType
	) => {
		const newSubscriptionTypeAfterFallback: GlobalEventSubscriberType = (() => {
			switch (currentSubscriptionType) {
				case 'data-api-trade-publisher':
					return 'dlob-server-trade-publisher';
				case 'dlob-server-trade-publisher':
					return 'events-server';
				case 'events-server':
					return 'websocket';
				case 'websocket':
					return 'polling';
				case 'polling':
					return 'dlob-server-trade-publisher'; // We loop back up to dlob-server-trade-publisher because data-api-trade-publisher is not battle-tested enough to be considered 100% reliable.
				default: {
					const _never: never = currentSubscriptionType;
					throw new Error(`Unhandled global event subscriber type: ${_never}`);
				}
			}
		})();

		return newSubscriptionTypeAfterFallback;
	},
};

export default EVENTS_SUBSCRIPTION_UTILS;
